module.exports = __webpack_public_path__ + "img/preview-svgrepo-com 1.91461060.svg";